<div class="page-content" [class.tucked]="_tabService.sideMenuTucked">
    <div class="tab-sidemenu">
        <!-- sidemenu-actions is reversed with css, so items are shown from right to left. -->
        <div class="sidemenu-actions" [class.tucked]="_tabService.sideMenuTucked">
            <div
                class="tuck-toggle"
                data-uiid="sidemenu-tuck-toggle"
                (click)="sideMenuTuckToggle()"
            >
                <i
                    class="far fa-chevron-double-{{
                        _tabService.sideMenuTucked ? 'right' : 'left'
                    }} fa-fw"
                ></i>
            </div>
            <div class="filler"></div>
        </div>

        @for (tab of tabs; track tab) {
            @if (tab.menu) {
                <ng-container>
                    <div
                        class="tab-menu-content"
                        [hidden]="_tabService.sideMenuTucked || tab.identifier !== activeTab"
                        [attr.data-uiid]="'tabmenu-' + tab.name"
                    >
                        @if (tab.menu.customMenu) {
                            <ng-container [ngTemplateOutlet]="tab.menu.customMenu"></ng-container>
                        } @else if (!tab.menu.customMenu && tab.menu.menuItems.length > 0) {
                            <cerrix-tabmenu [mainMenu]="tab.menu"></cerrix-tabmenu>
                        }
                    </div>
                    @if (!tab.menu.doNotShowTucked) {
                        <div
                            class="tab-menu-content tucked-content"
                            [hidden]="!_tabService.sideMenuTucked || tab.identifier !== activeTab"
                        >
                            <tuckedmenu [mainMenu]="tab.menu"></tuckedmenu>
                        </div>
                    }
                </ng-container>
            }
        }
    </div>
    <div class="tab-content">
        <div class="tab-bar" [class.no-indent]="_tabService.sideMenuTucked">
            <div class="tab-area" [class.overflow]="Overflow">
                @if (Overflow) {
                    <button class="scroll-button" (click)="scrollTab(-150)">
                        <i class="fas fa-chevron-left"></i>
                    </button>
                }
                <ul class="nav nav-tabs cerrix-tab sortable">
                    <li class="placeholder"></li>
                    @for (tab of tabs; track tab) {
                        <li
                            class="cerrix-tab-container"
                            [attr.data-uiid]="'tab-container-' + tab.name"
                            [class.active]="tab.identifier === activeTab"
                        >
                            <a
                                (mousedown)="mouseClick($event, tab)"
                                (contextmenu)="onContextMenu($event, tab)"
                            >
                                <div
                                    class="cerrix-tab-content"
                                    [attr.data-uiid]="'tab-content-' + tab.name"
                                    [title]="tab.name"
                                >
                                    <div class="filler">
                                        @if (tab.showLoader) {
                                            <i
                                                class="fas fa-circle-notch fa-spin"
                                                aria-hidden="true"
                                            >
                                            </i>
                                        }
                                    </div>
                                    <div data-uiid="tab-name" class="title">
                                        {{ tab.name }}
                                    </div>
                                    <div class="filler">
                                        @if (tab.closable) {
                                            <i
                                                class="fas fa-times clickable"
                                                aria-hidden="true"
                                                (click)="tab.close()"
                                                data-uiid="close-tab-button"
                                            ></i>
                                        }
                                        <i
                                            class="fas fa-ellipsis-v ms-2 clickable"
                                            aria-hidden="true"
                                            (click)="onContextMenu($event, tab)"
                                            data-uiid="option-tab-button"
                                        ></i>
                                    </div>
                                </div>
                            </a>
                        </li>
                    }
                </ul>
                @if (tabs.length > 2) {
                    <button class="close-all-button" (click)="closeTabs()" title="Close all tabs">
                        <i class="fas fa-times" aria-hidden="true"></i>
                    </button>
                }
                @if (Overflow) {
                    <button class="scroll-button" (click)="scrollTab(150)">
                        <i class="fas fa-chevron-right"></i>
                    </button>
                }
            </div>
        </div>

        @for (tab of tabs; track tab) {
            <div
                class="tab-page"
                [hidden]="tab.identifier !== activeTab"
                [id]="'view-' + tab.identifier"
                [class.full-height]="tab.url"
            >
                @if (renderedTabs.indexOf(tab.identifier) >= 0) {
                    @if (tab.comp) {
                        <tab-pane [cerrixTab]="tab" [id]="tab.identifier"> </tab-pane>
                    }
                    @if (tab.url) {
                        <iframe [src]="tab.url | safe" [id]="'iframe-' + tab.identifier"></iframe>
                    }
                }
            </div>
        }
    </div>
</div>

<cerrix-contextmenu [menu]="contextMenu" #contextMenuCmp></cerrix-contextmenu>
